module.exports = {
  almostFull: 'Almost Full',
  full: 'Full',
  private: 'Private Session',
};
